import React from "react";

const Working = ({ stubText }) => {
  return (
    <div className="middle">
      <h3>BuzzIQ Summary</h3>
      <span>{stubText}</span>
    </div>
  );
};

export default Working;
